import React, { useMemo } from 'react'
import { usePageLayout } from '../hooks/usePageLayout'

function Contact() {
  // Memoize layout options to prevent infinite re-renders
  const layoutOptions = useMemo(
    () => ({
      showSidebar: true,
      showHeader: true,
      showFooter: true,
      title: {
        en: 'Contact',
        zh_cn: '联系我们',
        zh_hk: '聯絡我們',
      },
    }),
    [],
  )

  // Contact page should show all navigation elements
  usePageLayout(layoutOptions)

  return (
    <>
      <h1 className="mt-40 ml-44 text-4xl font-extrabold">CONTACT PAGE</h1>
    </>
  )
}

export default Contact
